import { AppwriteException } from "appwrite";
import { AxiosError } from "axios";
import { ZodError } from "zod";
import { ModeGetAllAccounts, ParamsGetAllAccounts, ZodModeGetAllAccounts, ZodParamsGetAllAccounts } from '@/types';
import errorsController from '@/utils/errorsController';
import { customInstanceAWS } from "@/http";

type Args = ParamsGetAllAccounts & {mode: ModeGetAllAccounts}

export const getAllAccounts = async (mode: ModeGetAllAccounts, params?: ParamsGetAllAccounts) => {
 	try {
		const zMode = ZodModeGetAllAccounts.parse(mode);

    const zData = params ? ZodParamsGetAllAccounts.parse(params) : undefined;
		const args: {[k in keyof Args]: k extends 'is_demo' ? string | undefined : Args[k]} = {
			mode: zMode,
		}

		if (zData) {
			const {is_demo: isDemo, accountsId, ...rest} = zData
			args.is_demo = isDemo !== undefined ? isDemo.toString() : isDemo

			Object.assign(args, rest)
		}

    const formattedArgs = { ...args, accountsId: args.accountsId ? args.accountsId.join(',') : '' };

		return (await customInstanceAWS.get(`/accounts?${new URLSearchParams(formattedArgs).toString()}`)).data;
	} catch (err: AppwriteException | AxiosError | Error | unknown | ZodError) {
		if (err instanceof AppwriteException || err instanceof AxiosError || err instanceof Error || err instanceof ZodError) {
		  return errorsController(err);
		}
	}
}
